# Strategic Construction Projects Dashboard
# Initializes charts and tables when page loads

import * as echarts from 'echarts'
import './obras_dashboard_chart.coffee'
import './obras_dashboard_table.coffee'

$(document).on 'turbolinks:load', ->
  # Initialize Select2 for basic filters
  $('.select2').select2
    theme: 'bootstrap4'
    placeholder: 'Selecione...'
    allowClear: true
    width: '100%'

  # Tooltip for action buttons
  $('[data-toggle="tooltip"]').tooltip()

  # Confirmation for delete actions
  $('.link-remove').on 'click', (e) ->
    return true

#  # Add CSS class to body for specific styling
#  $('body').addClass('obras-dashboard-estrategico')

# Main coordinator that manages chart and table components
class ObrasDashboardEstrategico
  constructor: ->
    @chart = null
    @table = null
    @init()

  init: ->
    @initializeChart()
    console.log('iniciando')
    @initializeTable()

  initializeChart: ->
    @chart = new window.ObrasDashboardChart()
    @chart.init()
    @chart.loadData()

  initializeTable: ->
    @table = new window.ObrasDashboardTable()
    @table.init()
    
    # Connect table to chart for filter synchronization
    @table.setChartComponent(@chart)

  destroy: ->
    @chart?.destroy()
    @chart = null
    @table = null

# Auto-initialize when dashboard page is detected
$(document).on 'turbolinks:load', ->
  if window.location.pathname.includes('dashboard_estrategico') ||
     $('.obras-dashboard-estrategico').length > 0
    new ObrasDashboardEstrategico()
